import strapiApi from "../utils/strapiApi";
import { BANNER_CONTENT } from "./contentRoutes";

export const getBannerContentData = async () => strapiApi.get(BANNER_CONTENT);
